// start:ng42.barrel
import './settings-dashboard.component';
// end:ng42.barrel

